import { Divider } from '@heroui/react'

export const CircledDivider = () => (
  <div className='relative'>
    <span
      className={`absolute top-1/2 -left-10 inline-block h-10 w-10 -translate-y-1/2 rounded-full bg-white`}
    ></span>
    <Divider />

    <span
      className={`absolute top-1/2 -right-10 inline-block h-10 w-10 -translate-y-1/2 rounded-full bg-white`}
    ></span>
  </div>
)
